import { render, staticRenderFns } from "./low-route-button-cards.vue?vue&type=template&id=88caf8d6&"
import script from "./low-route-button-cards.vue?vue&type=script&lang=ts&"
export * from "./low-route-button-cards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports